import React from "react";

interface CalendarIconProps {
  onClick: () => void;
}

export const CalculationCalendarIcon = ({ onClick }: CalendarIconProps) => {
  return (
    <div
      role="button"
      onClick={onClick}
      className="inline-block cursor-pointer"
      aria-label="Open calendar"
      tabIndex={0} // make focusable for keyboard
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <img src="/aem-to-react/icons/Calendar.png" alt="Calendar icon" loading="lazy" className=""/>
    </div>
  );
};

export default CalculationCalendarIcon;
